import React from 'react'
import { styles } from 'helpers'
import { PieChart, Pie, Cell, ResponsiveContainer } from 'recharts'

class PieChartComponent extends React.Component {
  timer = null

  state = {
    mount: false,
  }

  componentDidMount() {
    this.timer = setTimeout(() => this.setState({ mount: true }), 1000)
  }

  componentWillUnmount() {
    clearTimeout(this.timer)
  }

  render() {
    const { data } = this.props

    if (!this.state.mount) {
      return null
    }
    return (
      <ResponsiveContainer height={300} width="100%">
        <PieChart>
          <Pie
            label={(entry) =>
              entry.value === 0
                ? undefined
                : entry.name.props && entry.name.props.id
            }
            labelLine={false}
            data={data}
            dataKey="value"
            startAngle={180}
            endAngle={540}
            outerRadius="50%"
            innerRadius="60"
          >
            {data?.map((entry, index) => (
              <Cell
                key={`cell-${index}`}
                fill={styles.colors.chart[index]}
                // strokeWidth={0}
              />
            ))}
          </Pie>
        </PieChart>
      </ResponsiveContainer>
    )
  }
}

export default PieChartComponent
